class CourseCalendar {

  constructor() {
    this.listen();
    this.setInitialSelectValue();
    this.listenToDropdown();
  }

  setInitialSelectValue() {
    this.filterCourses('Trafikalt grunnkurs (TG)');
    let filter = document.querySelector('.courseContainer .filter');
    if (filter) {
      filter.value = "Trafikalt grunnkurs (TG)";
    }
  }

  listenToDropdown() {
    let dropdowns = document.querySelectorAll('.filter');
    dropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', ev => {
        this.filterCourses(ev);
      });
    });
  }

  listen() {
    // Show courses that correspond with default selected value
    document.addEventListener('DOMContentLoaded', () => {

      let courseContainer = document.querySelectorAll('.courseContainer');
      courseContainer.forEach(container => {

        if (container.querySelector('.filter')) {
          let fullValue = container.querySelector('.filter').value;
          var regExp = /\(([^)]+)\)/;
          var matches = regExp.exec(fullValue);
          let license = matches[1];

          let courseFilter = container.querySelector('[name="coursefilter"]');
          let courseValues = courseFilter.value.split(', ');

          let courses = container.querySelectorAll('.course');
          courses.forEach(course => {
            let attribute = course.getAttribute("data-license");
            let courseText = course.firstElementChild.innerHTML;
            courseText = courseText.toLowerCase().replace('å', 'a').replace('æ', 'ae').replace('ø', 'o').replace('_', '');
            if (courseValues != "") {
              if (courseValues.includes(courseText) && attribute === license) {
                course.classList.remove('d-none')
              } else {
                course.classList.add('d-none')
              }
            } else {
              if (attribute !== license) {
                course.classList.add('d-none');
              } else {
                course.classList.remove('d-none');
              }
            }
          });
        } else {
          let licenseFilter = container.querySelector('[name="licensefilter"]');
          let licenseValues = licenseFilter.value.split(', ');

          let courseFilter = container.querySelector('[name="coursefilter"]');
          let courseValues = courseFilter.value.split(', ');

          let courses = container.querySelectorAll('.course');
          courses.forEach(course => {
            let license = course.getAttribute('data-license');

            let courseText = course.firstElementChild.innerHTML;
            courseText = courseText.toLowerCase().replace(/å/g, 'a').replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/ /g, '_').replace(/-/g, '');

            if (licenseValues && courseValues) {

              if (licenseValues.includes(license) && courseValues.includes(courseText)) {
                course.classList.remove('d-none');
              } else {
                course.classList.add('d-none');
              }
            } else if (licenseValues) {
              if (licenseValues.includes(license)) {
                course.classList.remove('d-none');
              } else {
                course.classList.add('d-none');
              }
            } else if (courseValues) {
              if (courseValues.includes(courseText)) {
                course.classList.remove('d-none');
              } else {
                course.classList.add('d-none');
              }
            }
          });

        }
        this.zebraify(container);
      });

    })

  }

  // Filter courses on dropdown-change
  filterCourses(ev) {
    let courseContainer;
    let license;
    if (typeof ev !== "string") {
      var regExp = /\(([^)]+)\)/;
      var matches = regExp.exec(ev.target.value);
      license = matches[1];
      courseContainer = ev.target.closest('.courseContainer');
    } else {
      license = ev;
      courseContainer = document.querySelector('.courseContainer');
    }

    if (courseContainer) {
      let courseFilter = courseContainer.querySelector('[name="coursefilter"]');
      let courseValues = courseFilter.value.split(', ');


      let courses = courseContainer.querySelectorAll('.course');
      courses.forEach(course => {
        let attribute = course.getAttribute("data-license");
        let courseText = course.firstElementChild.innerHTML;
        courseText = courseText.toLowerCase().replace('å', 'a').replace('æ', 'ae').replace('ø', 'o').replace('_', '');

        if (attribute !== license) {
          course.classList.add('d-none');
        } else {
          if (courseValues != "") {
            if (courseValues.includes(courseText)) {
              course.classList.remove('d-none')
            }
          } else {
            course.classList.remove('d-none');
          }
        }
      });
      this.zebraify(courseContainer);
    }
  }

  // Add striped css-class to displayed courses
  zebraify(calendar) {
    let courses = calendar.querySelectorAll('.course:not(.d-none)');
    for (let i = 0; i < courses.length; i++) {
      if (i % 2 == 0) {
        courses[i].classList.add('course--zebra');
      }
    }
  }

}

export default CourseCalendar;